<template>
  <div
    v-if="x && y"
    class="app-cursor-tooltip"
    :style="tooltipStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppCursorTooltip',
  data() {
    return {
      x: undefined,
      y: undefined,
    };
  },
  computed: {
    tooltipStyle() {
      if (!this.x || !this.y) return {};
      return { left: `${this.x + 10}px`, top: `${this.y}px` };
    },
  },
  mounted() {
    this.$parent.$el.addEventListener('mousemove', this.move);
  },
  beforeDestroy() {
    this.$parent.$el.removeEventListener('mousemove', this.move);
  },
  methods: {
    move(e) {
      this.x = e.clientX;
      this.y = e.clientY;
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-cursor-tooltip{
    position: fixed;
    display: inline-block;
    background-color: rgba(0,0,0,$lighten-opacity);
    color: #fff;
    border-radius: $border-radius-root;
    z-index: 1000;
    padding: 2px 6px;
    font-size: map-get($font-size, 'x-small')
  }
</style>
